import {DeleteKundeDialogState} from '../states/delete-kunde-dialog.state';
import {createReducer, on} from '@ngrx/store';
import {DeleteKundeDialogActions} from '../actions/delete-kunde-dialog.actions';


export const initialDeleteKundeDialogState: DeleteKundeDialogState = {
  isOpen: false,
};

export const deleteAbsenderDialogReducer = createReducer(
  initialDeleteKundeDialogState,

  on(
    DeleteKundeDialogActions.open,
    (state, action) => ({
      ...state,
      isOpen: true,
      kundeId: action.kundeId,
    })
  ),

  on(
    DeleteKundeDialogActions.close,
    () => ({
      ...initialDeleteKundeDialogState,
    })
  ),
);
